module.exports = __webpack_public_path__ + "media/components/assets/sujung_05-4c5874992c31705fef8382e39f466f6f.png";